const controllers = {
  home: require('./views/home'),
  dashboard: require('./views/dashboard'),
  tags: require('./views/tags'),
  corporate: require('./views/corporate'),
}

export default controllers
